
import React, { useContext, useEffect, useState } from "react";
import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";
import Testimonials from "../Testimonial";


function ProfessionalTax() {

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",

      }));
    }
  }, []);


  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };


  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_category: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);

  const service = services.find(s => s.service_id === 51);

  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }

    // Email validation
    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    // Phone number validation
    // if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
    //    newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    // }

    if (!newData.user_contact.trim()) {
      newErrors.user_contact = 'number is required.';
    } else if (!/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    // Category validation
    if (!newData.user_category) {
      newErrors.user_category = 'Please select a category.';
    }

    // City validation
    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };



  const formPutPartenshipdeed = async (e) => {
    e.preventDefault();
    // ✅ Check if user is logged in
    // if (!token) {
    //   alert("Please log in to continue.");
    //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    //   navigate('/login'); // 👈 Use this if you're using React Router
    //   return;
    // }
    if (!validateForm()) return;

     localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });

       // ✅ RESET FORM (SAFE)
  setNewData({
    user_name: '',
    user_email: '',
    user_contact: '',
    user_city: ''
  });

  };

  
      //   const formPutPartenshipdeed = async (e) => {
      //     e.preventDefault();
      
      //     if (!validateForm()) return;
      
      //     try {
      //         const response = await PartenerSheepDeedService.professionalTaxForm(newData);
      
      //         console.log("API Success:", response);
      
      //         navigate("/thankyou");
      
      //         // Optional: reset form
//     setNewData(prev => {
//   const resetObj = {};
//   Object.keys(prev).forEach(key => (resetObj[key] = ""));
//   return resetObj;
// });
    
      
      //     } catch (error) {
      //         console.error("API Error:", error);
      //         alert("Something went wrong!");
      //     }
      // };


  const professionalTaxData = [
  {
    state: "Karnataka",
    slabs: [
      { salaryRange: "Up to INR 15,000", tax: "Nil" },
      { salaryRange: "INR 15,001 and above", tax: "Rs. 200" },
    ],
  },
  {
    state: "Telangana",
    slabs: [
      { salaryRange: "Up to Rs. 15,000", tax: "Nil" },
      { salaryRange: "From Rs. 15,000–20,000", tax: "Rupees 150" },
      { salaryRange: "Above Rs. 20,000", tax: "Rupees 200" },
    ],
  },
  {
    state: "Maharashtra",
    slabs: [
      { salaryRange: "Up to Rs. 7,500 (men)", tax: "Nil" },
      { salaryRange: "Up to Rs. 10,000 (women)", tax: "Nil" },
      { salaryRange: "Rs. 7,500 to Rs. 10,000", tax: "Rupees 175" },
      { salaryRange: "Rs. 10,000 and above", tax: "Rupees 200 (Rupees 300 for February)" },
    ],
  },
];


  const faqList = [
  {
    question: "What is Professional Tax and who is liable to pay it?",
    answer: "Professional Tax is a tax levied by the state government on income earned by professionals, employees, and traders. Anyone earning an income from salary, profession, trade, or employment is liable to pay, as per the state’s slab."
  },
  {
    question: "Is Professional Tax applicable in all Indian states?",
    answer: "No, not all states in India impose Professional Tax. It is applicable only in certain states like Maharashtra, Karnataka, West Bengal, Tamil Nadu, etc. States like Delhi, Haryana, and Uttar Pradesh do not levy it."
  },
  {
    question: "How much is the Professional Tax amount?",
    answer: "The amount varies from state to state, usually ranging from ₹200 to ₹2,500 annually. It depends on the income slab and rules of the respective state government."
  },
  {
    question: "Who deducts and deposits Professional Tax for salaried individuals?",
    answer: "For salaried employees, the employer is responsible for deducting Professional Tax from the salary and depositing it with the government."
  },
  {
    question: "Are there any exemptions from Professional Tax?",
    answer: "Yes, exemptions are provided for certain categories such as parents of children with disabilities, individuals with permanent physical disabilities, members of the armed forces, and aged individuals (varies by state)."
  },
  {
    question: "What is the due date for paying Professional Tax?",
    answer: "The due date varies by state. For example, in Maharashtra, if there are more than 20 employees, payment is monthly. Otherwise, it may be annually. Delays can attract penalties and interest."
  },
  {
    question: "Can freelancers or self-employed professionals be liable to pay Professional Tax?",
    answer: "Yes, freelancers and self-employed professionals are also liable if their income exceeds the exempted limit defined by their state."
  },
  {
    question: "How can I register for Professional Tax online?",
    answer: "You can register through your state government’s tax department portal. It usually requires filling an online application, submitting documents, and receiving a registration certificate."
  },
  {
    question: "What documents are required for Professional Tax Registration?",
    answer: "Common documents include PAN card, address proof, identity proof, salary register (for employers), and certificate of incorporation (for companies)."
  },
  {
    question: "What happens if I don't pay Professional Tax on time?",
    answer: "Late payment or non-compliance can lead to penalties and interest as per the applicable state law. Repeated defaults can result in legal notices."
  }
];

const handleBannerClick = () => {
  const formElement = document.querySelector(".contact3-form-all");

  if (formElement) {
    formElement.classList.add("shake-effect");

    // remove effect after animation finishes
    setTimeout(() => {
      formElement.classList.remove("shake-effect");
    }, 400); // same as animation duration
  }
};

  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>
                <h1 className="sk-text-color">Professional Tax Registration</h1>
                <p className="pdrl-text">Get Professional Tax Registration Services for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                <p className="pd-text">Professional Tax (PT) is a state-imposed tax on income earned through employment or professional services. Dm2Legal experts can help you get registered for PT online quickly and hassle-free.</p>
                <p className="pd-text">Professional Tax is a tax imposed by the State Government on income earned through various professions like lawyers, CAs, or doctors, and is mandatory for most working individuals.</p>
                {/* <p className="pd-text">Connect with Dm2Legal experts today to get registered for Professional Tax hassle-free!</p> */}
                               <div className="banner" onClick={handleBannerClick}>
   <img src="assets/icons/banner.svg" alt="" />
</div>
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now </h3>
                  <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Final Price, No Hidden Costs)</span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label> {errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label> {errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                        <div className="col-12">
                          <label for="" className="dropdown-text">Category<span className="red">*</span></label> {errors.user_category && <p className="error-text">{errors.user_category}</p>}
                          <div className="niceSelect">
                            <select className="wide" onChange={(e) => setNewData({ ...newData, user_category: e.target.value })} value={newData.user_category}>
                              <option className="formop" data-display="Select Category...">Select Category...</option>
                              <option value="Sole Proprietorship / Individual">Sole Proprietorship / Individual</option>
                              <option value="Partnership / LLP">Partnership / LLP</option>
                              <option value="Private limited / Public limited / One person company">Private limited / Public limited / One person company</option>
                              <option value="HUF">HUF</option>
                              <option value="Society / Trust / Club">Society / Trust / Club</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <p className="pd-text">Professional Tax is a state-imposed tax applicable to all salaried individuals and working professionals. It is levied based on a person’s trade, profession, or employment. The tax rate varies from state to state, but the maximum amount charged is ₹2,500 per year.</p>
              <p className="pd-text">For assistance with Professional Tax and Registration, get in touch with the experts at Dm2Legal—they’ll guide you through the entire PTR process. When hiring staff for a business, the Professional Tax Registration Certificate must be applied for within 30 days of employment. If your business operates in multiple locations, separate applications must be filed with the respective state authorities for each jurisdiction.
              </p>
            </div>
          </div>
          <div className="space20"></div>

        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="hadding7">
              <div className="space40"></div>
              <h2 className="text-center">Professional Tax Return Filing and Payment </h2>
              <div className="space20"></div>
              <p className="pd-text"> Entities and individuals registered under Professional Tax are required to file returns regularly and pay the applicable tax within the prescribed timeline, which may be monthly or annually, based on state-specific rules.</p>
              <div className="space20"></div>
              <p className="pd-text">Filing Professional Tax returns is a statutory requirement mandated by state governments across India. It involves declaring and paying the collected tax amount.</p>
              <div className="space20"></div>
              <p className="pd-text">With the digitalization of India’s tax system, Professional Tax filing has become more streamlined. Most state tax departments now offer online platforms that make return submission simple and efficient.</p>


            </div>
          </div>
          <div className="col-lg-12">
            <p> &nbsp;</p>
            <p className="pd-text">Here are some key points to consider while complying with Professional Tax return filing:</p>
          </div>
          <div className="col-lg-8">
            <div className="hadding7">
              <div className="space20"></div>

              <div className="contact6-list">
                <ul>
                  <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Ensure timely payment of professional tax to avoid penalties.</li>
                  <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Get your Professional Tax Registration from the respective state authority.</li>
                  <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Maintain and submit accurate and complete documentation.</li>
                  <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Verify all data entered during filing, especially when claiming exemptions.</li>
                  <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Consult tax professionals or chartered accountants for proper guidance.</li>

                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            <img src="assets/img/images/Understanding-the-Trademark-Registration-Process-in-India.jpg" alt="" />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="hadding7">
              <div className="space40"></div>
              <h2 className="text-center">Professional Tax Slab </h2>
              <div className="space20"></div>
              <p className="pd-text">Professional Tax is levied by the respective state governments, and the applicable rate varies from one state to another. However, the tax is generally structured based on an individual's income slab. Under Article 276 of the Constitution of India, state governments are empowered to impose professional tax. The maximum amount that can be levied, as per the constitutional provision, is capped at ₹2,500 per annum.</p>
              <div className="space20"></div>
             


            </div>
          </div>
          <div className="col-lg-12">
            <p> &nbsp;</p>
           <div className="tax-table-container">
      <div className="table-header row">
        <div className="col state-column"><strong>State</strong></div>
        <div className="col salary-column"><strong>Monthly Salary (Gross)</strong></div>
        <div className="col tax-column"><strong>Professional Tax (per month)</strong></div>
      </div>

      {professionalTaxData.map((item, idx) => (
        <div className="table-body row mt-4" key={idx}>
          <div className="col state-column"><strong>{item.state}</strong></div>
          <div className="col salary-column">
            {item.slabs.map((slab, i) => (
              <p key={i}>{slab.salaryRange}</p>
            ))}
          </div>
          <div className="col tax-column">
            {item.slabs.map((slab, i) => (
              <p key={i}>{slab.tax}</p>
            ))}
          </div>
        </div>
      ))}
    </div>

          </div>
        

        
        </div>




        <div className="row">
          <div className="col-lg-12">
            <div className="hadding7">
              <div className="space40"></div>
              <h2 className="text-center">Professional Tax Registration Across India</h2>
              <div className="space20"></div>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="hadding7">
              <div className="space20"></div>
              <p className="pd-text">India’s taxation system is diverse, comprising various taxes for individuals and businesses. Professional Tax is one such state-level tax applicable to professionals and is a crucial legal requirement for those working in India. The tax rate varies by state and is based on fixed income slabs.</p>
              <div className="space20"></div>
              <p className="pd-text">Professional Tax Registration is mandatory for both employers and individuals who fall under the prescribed slabs of the Professional Tax Act. Registering ensures compliance with state tax laws and supports the lawful operation of professionals.</p>
              <div className="space20"></div>
              <p className="pd-text">As a key component of India’s tax structure, understanding and meeting Professional Tax registration and payment obligations is essential for maintaining smooth and lawful professional practices across the country.</p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="hadding7">
              <div className="space40"></div>
              <h2 className="text-center">Enrolment for Professional Tax Registration with Dm2Legal </h2>
              <div className="space40"></div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="contact6-list doc-list">
              <ul>
                <li className="font-f-7 ">
                  <div className="step-font-size"> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Registration Process</div>
                  <div className="space10"></div>
                  <p className="pd-text">Start by registering on our official platform—just provide your name, email, contact number, and service details.</p>
                </li>
                <hr />
                <li className="font-f-7">
                  <div className="step-font-size">  <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Documentation Process</div>
                  <div className="space10"></div>
                  <p className="pd-text">Once registered, submit the required documents for your chosen service. If you're missing any, our team will help you gather everything needed.</p>
                </li>

              </ul>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="contact6-list doc-list">
              <ul>
                <li className="font-f-7 ">
                  <div className="step-font-size"> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Operational Process</div>
                  <div className="space10"></div>
                  <p className="pd-text">Our experts ensure a smooth and efficient process as you engage with our services, making the entire experience hassle-free.</p>
                </li>
                <hr />
                <li className="font-f-7">
                  <div className="step-font-size">  <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Final Process</div>
                  <div className="space10"></div>
                  <p className="pd-text">After completing all steps, you'll receive your final registration results. In just a few working days, you’ll officially become a valued client of Dm2Legal.</p>
                </li>

              </ul>
            </div>
          </div>

        </div>

       
      </div>

      <div className="space20 bg-white"></div>

      

   




      <div className="service-binifits9 sp0" id="service2">
        <div className="container work8">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hadding7">
                <div className="space80"></div>
                <h2>
                  How to obtain Professional Tax Registration</h2>
              </div>
              <div className="partnership-deade-section">
                <div className="space40"></div>

                <ul className="disc-list">
                  <li> <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Professional Tax is imposed by states based on an individual’s income and profession, and the registration process may vary depending on the state.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Typically, registration is done online through the official website of the respective state government.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Applicants are required to fill in details such as income, profession, and other relevant information during the process.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Since each state may have a different procedure, it's essential to select the correct state for registration.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                    <span>Upon successful registration, a Professional Tax Certificate is issued, serving as proof of compliance with the state’s tax regulations.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                </ul>

                <div className="space80"></div>
              </div>
            </div>
          </div>
        </div>
      </div>


      

      <div className="space40 bg-white"></div>
      <div className="bg-white">

        <div className="container ">
           <div className="row">
          <div className="col-lg-12">
            <div className="hadding7">
              <div className="space40"></div>
              <h2 className="text-center">Documents Needed for Professional Tax  Registration</h2>
              <p className="text-center pd-text">Documents required for PT  registration</p>
              <div className="space20"></div>
            </div>
          </div>
          <div className="col-lg-5">
            <img src="assets/img/images/Documents-Needed-for-Trademark-Registration.png" alt="" />
          </div>
          <div className="col-lg-7">
            <div className="contact6-list doc-list">
              <ul>
                 <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Certificate of Incorporation or LLP Agreement (for LLPs)</li>
                    <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Memorandum of Association (MOA) and Articles of Association (AOA)</li>
                    <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>PAN Card of the business or individual</li>
                    <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>No Objection Certificate (if applicable)</li>
                    <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Passport-size photo of the applicant</li>
                    <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Address proof of the business owner</li>
                    <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Information about employees and the salaries/wages paid</li>
                    <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Any other relevant licenses or registrations (if available)</li>
              </ul>
            </div>
          </div>
        </div>
           {/* <div className="space40 bg-white"></div> */}
         
          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FAQs on Professional Tax Registration </h2>
                    <div className="space20"></div>


                    <div id="general">


                  
                   {faqList.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}









                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <Testimonials />



      <div className="sp2 last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">

                <h2>Why Choose Dm2Legal for Professional Tax Registration?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6">
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="single-service-1.html" >Easy PT Registration</a></h4>
                  <p>At Dm2Legal, registering for Professional Tax (PT) is quick and straightforward. Simply provide your name, email, contact number, and select the PT registration service you need. After your online registration, our team will get in touch with you to assist with the necessary formalities.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="single-service-1.html" >Trusted Online Platform</a></h4>
                  <p>Dm2Legal stands out as one of India’s leading online platforms for PT registration. No matter where you are, our extensive client network and efficient online process ensure you receive your PT registration without any hassle.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="single-service-1.html" >Reliable Customer Support</a></h4>
                  <p>Our dedicated team is known for offering comprehensive support throughout your PT registration journey. We assist you not just during registration, but also afterward, welcoming your feedback to continually enhance our service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Professionals</a></h4>
                  <p>With over 10 years of industry experience, our experts specialize in PT registration. Choosing Dm2Legal means partnering with seasoned professionals who guarantee a smooth and efficient registration process.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Prompt Service</a></h4>
                  <p>We value your time and begin working on your PT registration as soon as you register with us. Our team is committed to delivering timely service without delays.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="single-service-1.html" >Affordable and Quality Service</a></h4>
                  <p>Dm2Legal provides cost-effective PT registration services without compromising quality. Your satisfaction and budget are always our top priorities.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>


      <WhatsAppScrollButton />
      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default ProfessionalTax;